/* ==========================================================================
   PLUFFI — BUNDLE VARIANTS (NO FREEBIES, NO KACHING)
   Bundle logic:
   - Single (1 pair)            → no discount
   - 2 Pairs (bundle 2)         → -10$ discount (USA/GBP) or -15$ (CAD)
   - 3 Pairs (bundle 3)         → -25$ discount (USA/GBP) or -35$ (CAD)
   Price UI only — discounts applied by Shopify codes.
   ========================================================================== */

(() => {

  if (window.__VR_BUNDLE_INIT__) return;
  window.__VR_BUNDLE_INIT__ = true;

  // ---- 0) Focus guards (avoid Dawn focus-trap crash) ----
  (function installFocusGuards() {
    const W = window;
    const origG = W.getFocusableElements;
    W.getFocusableElements = function (container) {
      if (!container) return [];
      try { if (typeof origG === "function") return origG(container) || []; } catch {}
      return Array.from(container.querySelectorAll('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])'));
    };
    const origT = W.trapFocus;
    W.trapFocus = function (container, ...rest) {
      if (!container) return;
      try { if (typeof origT === "function") return origT(container, ...rest); } catch {}
    };
  })();

  // ---- 0.b) Safety CSS if theme over-hides drawer ----
  (function installDrawerDebugCSS(){
    if (document.getElementById('drawer-debug-css')) return;
    const s = document.createElement('style');
    s.id = 'drawer-debug-css';
    s.textContent = `
      cart-drawer .drawer__inner{opacity:1!important;visibility:visible!important}
      cart-drawer .drawer__contents{display:block!important;opacity:1!important;visibility:visible!important}
      .vr-size-selects{display:flex;flex-direction:column;gap:8px}
      .vr-size-row{display:flex;align-items:center;gap:8px}
      .vr-size-index{min-width:1.6em;text-align:right;font-weight:600;opacity:.6}
    `;
    document.head.appendChild(s);
  })();

  document.addEventListener("DOMContentLoaded", () => {

    /* ================================
       DOM ELEMENTS
    =================================*/
    const form = document.getElementById("vr-bundle-form");
    if (!form) return;

    const buyNowBtn        = document.querySelector(".vr-buy-now-btn");
    const itemsRemainingEl = document.querySelector(".vr-items-remaining");

    const addButtons  = [...document.querySelectorAll(".vr-add-variant-btn")];
    const plusButtons = [...document.querySelectorAll(".vr-quantity-btn.plus")];
    const minusButtons= [...document.querySelectorAll(".vr-quantity-btn.minus")];

    /* ================================
       PRICE BASE
    =================================*/
    const product = window.productData || {};
    const baseVariant = product.variants?.find(v => v.available) || product.variants?.[0];
    const BASE_PRICE = baseVariant?.price || 0;   // in cents

    /* ================================
       DISCOUNTS PER OFFER (AVEC SUPPORT CANADA)
    =================================*/
    const country = window.countryCode || "US";
    
    const DISCOUNTS = {
      single:      0,
      buy2save10:  (country === "CA") ? 1500 : 1000,  // ✅ 15$ CAD ou 10$ USD/GBP
      buy3save25:  (country === "CA") ? 3500 : 2500   // ✅ 35$ CAD ou 25$ USD/GBP
    };

    /* ================================
       FORMATTER
    =================================*/
    const currency = Shopify.currency?.active || "USD";
    const lang     = document.documentElement.lang || "en-US";

    const moneyFmt = new Intl.NumberFormat(lang, { style: "currency", currency });
    const fmt      = cents => moneyFmt.format((cents || 0) / 100);

    const toInt = x => parseInt(x || "0", 10);


    /* ================================
       OFFER LOGIC
    =================================*/
    function getRequiredQty() {
      const r = document.querySelector(".vr-quantity-radio:checked");
      return toInt(r?.dataset.quantity || "1");
    }

    function getDiscount() {
      const r = document.querySelector(".vr-quantity-radio:checked");
      const key = r?.value || "single";
      return DISCOUNTS[key] || 0;
    }


    /* ================================
       COUNT SELECTED VARIANTS
    =================================*/
    function totalSelected() {
      let sum = 0;
      document.querySelectorAll(".vr-quantity-value").forEach(el => sum += toInt(el.textContent));
      return sum;
    }


    /* ================================
       UPDATE UI STATE
    =================================*/
    function updateState() {
      const required = getRequiredQty();
      const selected = totalSelected();
      const remaining = Math.max(required - selected, 0);

      if (required === 1) {
        itemsRemainingEl.textContent =
          selected === 0 ? "CHOOSE YOUR PAIR" : "Nice pick! ✅";
      } else {
        if (remaining > 0) {
          itemsRemainingEl.textContent =
            `${selected} of ${required} ADDED – ${remaining} more to go!`;
        } else {
          itemsRemainingEl.textContent = "Bundle complete ✅";
        }
      }

      addButtons.forEach(btn => btn.disabled = remaining <= 0);
      plusButtons.forEach(btn => btn.disabled = remaining <= 0);

      buyNowBtn.disabled = remaining !== 0;
      buyNowBtn.querySelector(".vr-buy-now-btn-text").textContent =
        remaining === 0 ? "Confirm ✅" : "Select variants";
    }


    /* ================================
       RESET ALL VARIANT CARDS
    =================================*/
    function hardResetAllCards() {
      document.querySelectorAll(".vr-variant-item").forEach(card => {
        const ctrl = card.querySelector(".vr-quantity-control");
        const add  = card.querySelector(".vr-add-variant-btn");
        const val  = card.querySelector(".vr-quantity-value");

        val.textContent = "0";
        ctrl.style.display = "none";
        add.style.display = "block";

        const box = card.querySelector(".vr-size-selects") || makeSizeBox(card);
        [...box.querySelectorAll(".vr-size-row")].forEach((row,i) => {
          if (i > 0) row.remove();
        });
      });
    }


    /* ================================
       SIZE ROW MANAGEMENT
    =================================*/
    function makeSizeBox(card) {
      let box = card.querySelector(".vr-size-selects");
      if (!box) {
        const actions = card.querySelector(".vr-variant-actions");
        const firstSelect = card.querySelector(".vr-variant-size-select");

        box = document.createElement("div");
        box.className = "vr-size-selects";

        const row = document.createElement("div");
        row.className = "vr-size-row";
        row.appendChild(firstSelect);

        actions.appendChild(box);
        box.appendChild(row);
      }
      return box;
    }

    function ensureSizeRows(card, count) {
      count = Math.max(1, count);

      const box = makeSizeBox(card);
      let rows = [...box.querySelectorAll(".vr-size-row")];
      const template = rows[0].querySelector("select");

      while (rows.length < count) {
        const clone = template.cloneNode(true);
        const row = document.createElement("div");
        row.className = "vr-size-row";
        row.appendChild(clone);
        box.appendChild(row);
        rows.push(row);
      }

      while (rows.length > count) {
        box.removeChild(rows.pop());
      }
    }


    /* ================================
       QUANTITY BUTTON HANDLERS
    =================================*/
    addButtons.forEach(btn => {
      btn.addEventListener("click", () => {
        if (totalSelected() >= getRequiredQty()) return;

        const card = btn.closest(".vr-variant-item");
        const ctrl = card.querySelector(".vr-quantity-control");
        const val  = card.querySelector(".vr-quantity-value");

        btn.style.display = "none";
        ctrl.style.display = "flex";
        val.textContent = "1";

        ensureSizeRows(card, 1);
        updateState();
      });
    });

    plusButtons.forEach(btn => {
      btn.addEventListener("click", () => {
        if (totalSelected() >= getRequiredQty()) return;

        const card = btn.closest(".vr-variant-item");
        const val  = card.querySelector(".vr-quantity-value");

        const newV = toInt(val.textContent) + 1;
        val.textContent = String(newV);

        ensureSizeRows(card, newV);
        updateState();
      });
    });

    minusButtons.forEach(btn => {
      btn.addEventListener("click", () => {
        const card = btn.closest(".vr-variant-item");
        const ctrl = card.querySelector(".vr-quantity-control");
        const add  = card.querySelector(".vr-add-variant-btn");
        const val  = card.querySelector(".vr-quantity-value");

        const n = toInt(val.textContent);

        if (n > 1) {
          val.textContent = String(n - 1);
          ensureSizeRows(card, n - 1);
        } else {
          val.textContent = "0";
          ctrl.style.display = "none";
          add.style.display = "block";
          ensureSizeRows(card, 1);
        }

        updateState();
      });
    });


    /* ================================
       PRICE UI (WITH DISCOUNTS)
    =================================*/
    function recalcPrices() {
      const required = getRequiredQty();
      const discount = getDiscount();

      const compare = BASE_PRICE * required;
      const final   = compare - discount;

      document.querySelector("#compare-price").textContent = fmt(compare);
      document.querySelector("#final-price").textContent   = fmt(final);
    }

    document.querySelectorAll(".vr-quantity-radio").forEach(r => {
      r.addEventListener("change", () => {
        hardResetAllCards();
        updateState();
        recalcPrices();
      });
    });


    /* ================================
       SUBMIT → ADD TO CART
    =================================*/
    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      if (totalSelected() !== getRequiredQty()) {
        document.querySelector(".vr-step:nth-of-type(2)")
          .scrollIntoView({ behavior: "smooth" });
        return;
      }

      const itemsMap = {};

      document.querySelectorAll(".vr-variant-item").forEach(card => {
        const qty = toInt(card.querySelector(".vr-quantity-value").textContent);
        if (qty <= 0) return;

        const selects = card.querySelectorAll(".vr-size-selects select");
        for (let i = 0; i < qty; i++) {
          const id = toInt(selects[i].value);
          itemsMap[id] = (itemsMap[id] || 0) + 1;
        }
      });

      const fd = new FormData();
      let index = 0;

      Object.entries(itemsMap).forEach(([id, qty]) => {
        fd.append(`items[${index}][id]`, id);
        fd.append(`items[${index}][quantity]`, qty);
        index++;
      });

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/json" },
          body: fd
        });
        await res.json().catch(() => ({}));
        
        // ✅ Utilise la vraie fonction de refresh du drawer
        await refreshCartDrawerNL();
        
        document.dispatchEvent(new Event("ajaxProduct:added"));
      } catch (err) {
        console.error("[bundle] /cart/add.js error → /cart", err);
        window.location.href = "/cart";
      }
    });


    /* ================================
       INITIALISE
    =================================*/
    document.querySelectorAll(".vr-variant-item").forEach(makeSizeBox);
    updateState();
    recalcPrices();

  });


  /* ================================
     DRAWER REFRESH (COMPLET)
  =================================*/
  async function refreshCartDrawerNL() {
    const [cart, drawerHtml] = await Promise.all([
      fetch("/cart.js", { headers: { Accept: "application/json" } }).then((r) => r.json()),
      fetch("/?section_id=cart-drawer", { headers: { "X-Requested-With": "XMLHttpRequest" } }).then((r) => r.text()),
    ]);

    const doc   = new DOMParser().parseFromString(drawerHtml, "text/html");
    const fresh = doc.querySelector("#CartDrawer");
    const host  = document.querySelector("#CartDrawer");
    
    if (!fresh || !host) { 
      window.location.href = "/cart"; 
      return; 
    }
    
    host.innerHTML = fresh.innerHTML;

    // Update header bubble
    try {
      const count = cart?.item_count ?? 0;
      const bubble =
        document.querySelector("#cart-icon-bubble .cart-count-bubble") ||
        document.querySelector(".cart-count-bubble") ||
        document.querySelector("#CartCount") ||
        document.querySelector("[data-cart-count]");
      
      if (bubble) {
        if (bubble.hasAttribute("data-cart-count")) {
          bubble.setAttribute("data-cart-count", String(count));
        }
        bubble.textContent = String(count);
      }
    } catch {}

    // Toggle empty state
    const drawerEl   = document.querySelector("cart-drawer");
    const innerEmpty = host.querySelector(".drawer__inner-empty");
    const itemsEl    = host.querySelector("cart-drawer-items");
    const isEmpty    = (cart?.item_count ?? 0) === 0;
    
    if (drawerEl) drawerEl.classList.toggle("is-empty", isEmpty);
    if (innerEmpty) innerEmpty.style.display = isEmpty ? "block" : "none";
    if (itemsEl) itemsEl.classList.toggle("is-empty", isEmpty);

    // Focus safety
    try {
      const main = drawerEl?.querySelector(".drawer__inner") || drawerEl?.querySelector("#CartDrawer") || drawerEl;
      if (drawerEl) drawerEl.mainDetails = main;
      
      if (main && !main.querySelector('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])')) {
        const b = document.createElement("button");
        b.type = "button";
        b.tabIndex = 0;
        b.style.cssText = "position:absolute;left:-9999px;top:auto;width:1px;height:1px;overflow:hidden";
        b.setAttribute("aria-hidden","true");
        main.appendChild(b);
      }
    } catch {}

    // Open drawer
    await safeOpenCartDrawer(drawerEl);
    wireOverlayClose();

    // Dispatch events
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
    document.dispatchEvent(new Event("cart:open"));
    window.dispatchEvent(new CustomEvent("cart:refresh", { detail: cart }));
  }

  async function safeOpenCartDrawer(drawerEl) {
    if (!drawerEl) return;
    try { 
      if (typeof drawerEl.open === "function") { 
        drawerEl.open(); 
        return; 
      } 
    } catch {}
    
    drawerEl.classList.add("is-open", "open", "active");
    drawerEl.setAttribute("open", "");
  }

  function wireOverlayClose() {
    const drawerCE = document.querySelector("cart-drawer");
    if (!drawerCE) return;
    
    const overlay = drawerCE.querySelector("#CartDrawer-Overlay");
    if (overlay && !overlay.__vrBound) {
      overlay.__vrBound = true;
      overlay.addEventListener("click", (e) => {
        e.preventDefault(); 
        e.stopPropagation();
        
        try { 
          if (typeof drawerCE.close === "function") drawerCE.close(); 
        } catch {}
        
        drawerCE.classList.remove("is-open", "open", "active");
        drawerCE.removeAttribute("open");
        document.documentElement.classList.remove('js-drawer-open','overflow-hidden','no-scroll','lock-scroll');
        document.body.classList.remove('js-drawer-open','overflow-hidden','no-scroll','lock-scroll');
        document.body.style.overflow = '';
      });
    }
  }

  // ---- 4) Hard-close helpers for mobile overlay edge-cases ----
  (function cartOverlayHardClosePatch(){
    function closeDrawerHard() {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      try { drawer.close?.(); } catch {}
      drawer.classList.remove('is-open','open','active','drawer--open');
      drawer.removeAttribute('open');
      const ov = drawer.querySelector('#CartDrawer-Overlay');
      if (ov) { ov.style.opacity = '0'; ov.style.visibility = 'hidden'; ov.style.pointerEvents = 'none'; }
      document.documentElement.classList.remove('js-drawer-open','overflow-hidden','no-scroll','lock-scroll');
      document.body.classList.remove('js-drawer-open','overflow-hidden','no-scroll','lock-scroll');
      document.body.style.overflow = '';
    }
    window.__closeDrawerHard = closeDrawerHard;
    document.addEventListener('click', (e) => {
      if (e.target && e.target.id === 'CartDrawer-Overlay') { e.preventDefault(); e.stopPropagation(); closeDrawerHard(); }
    }, true);
    document.addEventListener('keyup', (e) => { if (e.key === 'Escape') closeDrawerHard(); });
    window.addEventListener('popstate', closeDrawerHard);
    window.addEventListener('pageshow', () => {
      const d = document.querySelector('cart-drawer');
      if (d && !d.classList.contains('open') && !d.hasAttribute('open')) closeDrawerHard();
    });
    document.addEventListener('cart:close', () => setTimeout(closeDrawerHard, 50));
  })();

})();